import { lazy } from 'react'

const ShareProductLazy = lazy(() =>
  import(/* webpackChunkName: "ShareProduct" */ './shareProduct'),
)

export default ShareProductLazy
